// Copyright (c) Bentley Systems
import { useMemo } from "react";
import { useAppSelector } from "../app/hooks";
import { selectTheme } from "../app/theme-slice";
const EntryScreen = () => {
  // Read the URL parameters

  const themeState = useAppSelector(selectTheme);
  const backgroundClassName = useMemo((): string => {
    return themeState.isDark === true
      ? "entryScreen entryScreenDarkBackground"
      : "entryScreen entryScreenWhiteBackground";
  }, [themeState.isDark]);

  return (
    <div className={backgroundClassName}>
      <div />
    </div>
  );
};

export default EntryScreen;
